<template>
    <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4">
        <!-- Први див (1/3) -->
        <div class="flex flex-col gap-4 z-50 md:col-span-1 lg:col-span-1">
            <!-- Card 1 -->
            <div class="rounded-lg flex-1 bg-blue-900 shadow-md text-white p-4">
                <div class="max-w-full w-full px-4">
                    <h1
                        class="text-4xl sm:text-6xl md:text-6xl font-extrabold text-white break-words leading-tight"
                    >
                        {{ $t("scientists.news").toUpperCase() }}
                    </h1>
                </div>
                <ul v-if="articles">
                    <li
                        class="relative mt-4"
                        v-for="article in articles"
                        :key="article.id"
                    >
                        <NuxtLink
                            :to="$localeRoute(`/scientists/news/${article.id}`)"
                        >
                            <b class="mr-4">{{
                                article.title || "No Title"
                            }}</b>
                            <svg
                                class="absolute -bottom-3 right-0"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 100 100"
                                width="50"
                                height="50"
                            >
                                <!-- Arrow -->
                                <path
                                    d="M20,50 L80,50 M50,20 L80,50 L50,80"
                                    fill="none"
                                    stroke="white"
                                    stroke-width="5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </NuxtLink>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Други див (2/3) -->
        <div class="flex flex-col gap-4 z-50 md:col-span-2 lg:col-span-2">
            <h1 class="text-4xl text-blue-900">
                {{ $t("scientists.cliniciansAndScientists") }}
            </h1>
            <div
                class="mt-4"
                v-html="`<p>${$t('scientists.content')}</p>`"
            ></div>
            <div class="flex justify-end">
                <NuxtLink :to="$localeRoute('/contact')">
                    <button
                        class="bg-blue-900 text-white p-2 w-full rounded-xl"
                    >
                        {{ $t("scientists.contactUs").toUpperCase() }}
                    </button>
                </NuxtLink>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useHead } from "#imports";

useHead({
    title: "Scientists - Cardioteam",
    meta: [
        {
            name: "description",
            content: "Cardioteam scientists and clinicians",
        },
        {
            name: "keywords",
            content: "Cardioteam, scientists, clinicians",
        },
        {
            name: "author",
            content: "Cardioteam",
        },
        {
            name: "og:title",
            content: "Scientists - Cardioteam",
        },
        {
            name: "og:description",
            content: "Cardioteam scientists and clinicians",
        },
    ],
});
const articles = ref([]);
const fetchArticles = async () => {
    const response = await $fetch("/api/articles");
    articles.value = response.body || [];
};

onMounted(fetchArticles);
</script>

<style scoped></style>
